import React from "react";

const TopBar = ({ ...props }) => {
  // useEffect(() => {
  //   let Menu = document.getElementById("Menu");
  //   let Gallery = document.getElementById("Gallery");
  // }, []);
  console.log(props, "PROPSPROPS");
  // let updateToggle = (e) => {
  //   let target = e.target;
  //   console.log(target);
  //   if (target.tagName === "A") {
  //     props.setToggleFunction(target.id);
  //   } else {
  //     props.setToggleFunction(target.parentNode.id);
  //   }
  // };
  return (
    <header>
      {/* <div className="h-title" id="h-title">
        <a href={props.setToggle} id={"menu"} onClick={updateToggle}>
          <h1>Menu</h1>
        </a>
        <a href={props.setToggle} id={"gallery"} onClick={updateToggle}>
          <h1>Gallery</h1>
        </a>
      </div> */}
      <div
        className={`${props.toggle === "gallery" && "invisible"} h-scroller`}
        id="h-scroller"
      >
        {/* <div className="h-scroller" id="h-scroller"> */}
        <a href="#logo">
          {" "}
          <button className="quick-access-btn">All</button>
        </a>
        {props.menu.map((value, key) => {
          // console.log(value);
          if (key > 0) {
            key -= 1;
          }else{
            key="logo"
          }
          return (
            <a key={key} href={`#${key}`}>
              <button className="quick-access-btn">{value.name}</button>
            </a>
          );
        })}
      </div>
    </header>
  );
};

export default TopBar;
